import { render, staticRenderFns } from "./appFooter2.vue?vue&type=template&id=1d75d14c&scoped=true&"
import script from "./appFooter2.vue?vue&type=script&lang=js&"
export * from "./appFooter2.vue?vue&type=script&lang=js&"
import style0 from "./appFooter2.vue?vue&type=style&index=0&id=1d75d14c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d75d14c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VFooter,VIcon,VLayout,VSpacer})
